export default {
  SET_DATA: '@YOLA_TEMPLATE_GALLERY/TEMPLATES/SET_DATA',
  CREATE_SITE: '@YOLA_TEMPLATE_GALLERY/TEMPLATES/CREATE_SITE',
  SET_SINGLE: '@YOLA_TEMPLATE_GALLERY/TEMPLATES/SET_SINGLE',
};
